// export const GENRATE_OTP = 'https://dev-fargate-wearable-hub-api.boat-lifestyle.com/v1/auth/otp/generate';
// export const VERIFY_OTP = 'https://dev-fargate-wearable-hub-api.boat-lifestyle.com/v1/auth/login/mobile'
// export const DELETE_URL = 'https://dev-fargate-wearable-hub-api.boat-lifestyle.com/v1/users/delete'
// export const COUNTRY_CODE = 'https://dev-fargate-wearable-hub-api.boat-lifestyle.com/v1/countrycode/codes'


export const GENRATE_OTP = 'https://wearable-hub-api.boat-lifestyle.com/v1/auth/otp/generate';
export const VERIFY_OTP = 'https://wearable-hub-api.boat-lifestyle.com/v1/auth/login/mobile'
export const DELETE_URL = 'https://wearable-hub-api.boat-lifestyle.com/v1/users/delete'
export const COUNTRY_CODE = 'https://wearable-hub-api.boat-lifestyle.com/v1/countrycode/codes'

